import React from 'react';

import './main.scss';

export const Main = ({ children, style }) => (
  <article style={style} className="main">
    {children}
  </article>
);
